import { TextComponent } from 'design/text/textComponents';
import { DemoStackManagerIntl } from 'types/i18n';
import React from 'react';
import { ParagraphComponent } from 'design/paragraph';
import { NON_BREAKING_SPACE } from 'utils/constants';

export const demoStackManagerIntl: DemoStackManagerIntl = {
  demoCreationTitleText: 'Демо создается…',
  demoFailedTitleText: 'Демо недоступно',
  demoFailedDescriptionText(mailLink, tgLink) {
    return (
      <TextComponent>
        <ParagraphComponent>
          Извините, создание аккаунта временно недоступно из-за большого
          количества запросов.
        </ParagraphComponent>
        <ParagraphComponent>
          Создайте аккаунт позже или обратитесь в поддержку:{'\n'}email{' '}
          {mailLink}, telegram {tgLink}
        </ParagraphComponent>
      </TextComponent>
    );
  },
  demoFailedActionText: 'Создать демоверсию',

  demoReadyTitleText() {
    return (
      <TextComponent size="l" family="futura">
        {'Демоверсия '}
        <TextComponent size="l" family="futura" color="accent">
          {'на' + NON_BREAKING_SPACE + '7' + NON_BREAKING_SPACE + 'дней'}
        </TextComponent>
      </TextComponent>
    );
  },
  demoReadyDescriptionText: `Демоверсия уже заполнена информацией. Это позволит вам более детально изучить как выглядит и работает программа изнутри.

Вы можете совершать любые действия с данными. Все${NON_BREAKING_SPACE}изменения будут храниться 7 дней.`,
  demoReadyActionText: 'Перейти к просмотру демо',
};
